import Geocode from 'react-geocode';

import { IAddressData } from '../interfaces';

import api from 'services/api';

interface IAddressDataForm {
  id?: string;
  name: string;
	street: string;
	neighborhood: string;
	number: string;
	cep: string;
	complement: string;
	geolocation?: {
		latitude: string;
		longitude: string;
	},
	city_ibge_code: string;
  created_at?: string;
  user_id?: string;
  updated_at?: string;
  time_zone?: string;
  main?: boolean;
  city_id?: string;
}

interface ISubmitAddressFormDataProps {
  addressData: IAddressData;
  providerId: string;
}

export const SubmitAddressFormData = async ({
  addressData, providerId
}: ISubmitAddressFormDataProps) => {
  Geocode.setApiKey(process?.env?.REACT_APP_GEOCODE_KEY || '');
  Geocode.setLanguage("pt-BR");

  const name = `${addressData?.cep}, ${addressData?.number}`;
  const coordinatesAddress = `${addressData?.cep}, ${addressData?.street}, ${addressData?.number}`

  try {
    /* const coordinatesResponse = await Geocode.fromAddress(coordinatesAddress)
    const { lat: latitude, lng: longitude } = coordinatesResponse.results[0].geometry.location; */

    const AddressFormData: any = {
      ...addressData,
      main: true,
      name,
      complement: addressData?.complement?.trim() || ' ',
      /* geolocation: {
        latitude,
        longitude
      }, */
    }

    if(AddressFormData.id) delete AddressFormData.id;
    if(AddressFormData.geolocation) delete AddressFormData.geolocation;
    if(AddressFormData.time_zone) delete AddressFormData.time_zone;
    if(AddressFormData.city_id) delete AddressFormData.city_id;
    if(AddressFormData.updated_at) delete AddressFormData.updated_at;
    if(AddressFormData.user_id) delete AddressFormData.user_id;
    if(AddressFormData.created_at) delete AddressFormData.created_at;
    delete AddressFormData.is_deleted;

    console.log('AddressFormData',AddressFormData);
    
    const response: any = await api.post('/addresses', AddressFormData)

    await api.post(`/providers/${providerId}/addresses`,{
      address_id: response?.data?.id
    })

    return Promise.resolve();
  } catch (error: any) {
    return Promise.reject(error?.response?.data?.message);
  }
}
